import React from "react";
import { useSelector } from "react-redux";
import HorizontalPanel from "../../../components/HorizontalPanel";
import {
  useTypedDispatch
} from "../../../app/state";
// import WirelessInterfaceBestPracticeBadge from "../../Shared/WirelessInterfaceBestPracticeBadge";
import { Toolbar } from "../../../app/components";
import { IconButton } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import { AddWirelessInterfaceDialog } from "../DevicesMainPanel/dialogs/AddWirelessInterfaceDialog";
import { ModalType } from "../../../app/shared/modal-context/constants";
import { deleteWirelessInterface } from "../../../store/deviceStore/deviceRequests";
import { useShowModal } from "../../../app/shared/modal-context/modal.context";
import WirelessInterfaceModel from "../../../models/WirelessInterfaceModel";
import { selectAllLicenceList } from "../../../store/licenceStore/licenceSelectors";
import MenuList from "../../../components/MenuList";
import LicenceIconLink from "../../Shared/LicenceIconLink";

interface WirelessInterfaceListProps {
  wirelessInterfaceList: WirelessInterfaceModel[],
  currentWirelessInterfaceId?: number | null,
  formDisabled?: boolean;
  showButtons?: boolean;
  onWirelessInterfaceSelect?: (id: number) => any,
  onAddWirelessInterface?: (id: number) => any,
  onAfterDelete?: () => any,
}

const WirelessInterfaceList = ({
  wirelessInterfaceList,
  currentWirelessInterfaceId,
  formDisabled,
  showButtons = true,
  onWirelessInterfaceSelect = () => {},
  onAddWirelessInterface = () => {},
  onAfterDelete = () => {},
}: WirelessInterfaceListProps) => {
  const dispatch = useTypedDispatch();
  const { showModal } = useShowModal();
  const licenceList = useSelector(selectAllLicenceList);

  const items = wirelessInterfaceList.map((wirelessInterface) => {
    const licence = licenceList.find((licence) => licence.id === wirelessInterface.licenceId)

    return {
      id: wirelessInterface.id,
      name: wirelessInterface?.technologyConfiguration?.name,
      secondary: licence?.name || '',
      rightIcon: <LicenceIconLink licence={licence} />
    }
  })

  const onDelete = () => {
    if (!currentWirelessInterfaceId) {
      return;
    }

    dispatch(deleteWirelessInterface(currentWirelessInterfaceId))
      .then(() => {
        onAfterDelete();
      })
  }

  const onDeleteWirelessInterface = () => {
    showModal(ModalType.MODAL_GENERIC_CONFIRM, {
      title: 'Delete wireless interface',
      text: 'You are about to delete the selected wireless interface. Are you sure?',
      confirmButtonHandler: onDelete,
      confirmButtonText: "Delete",
    });
  }

  return (
    <>
      <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
        <Toolbar title='Interfaces'>
          {
            showButtons ? (
              <>
                <IconButton
                  disabled={!!formDisabled || !currentWirelessInterfaceId}
                  aria-label='Delete wireless interface'
                  color='secondary'
                  size='small'
                  onClick={onDeleteWirelessInterface}
                >
                  <Delete />
                </IconButton>
                <AddWirelessInterfaceDialog
                  disabled={!!formDisabled}
                  onAdd={onAddWirelessInterface}
                  wirelessInterfaces={wirelessInterfaceList}
                />
              </>
            ) : null
          }
        </Toolbar>
      </HorizontalPanel>
      <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
        <MenuList
          size='big'
          items={items}
          selectItem={onWirelessInterfaceSelect}
          selectedItemId={currentWirelessInterfaceId}
        />
      </HorizontalPanel>
    </>
  )
}

export default WirelessInterfaceList;